// import components
import type { BoxProps } from '@mui/material';
import { styled, Box } from '@mui/material';

export const StyledPlanUnitsHomeBox = styled(Box)(({ theme }) => ({
  margin: theme.spacing(3, 3, 14, 3)
}));

export const StyledPlanUnitSelectorBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2)
}));

export const StyledTopBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3)
}));

export const StyledBottomBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2)
}));

export const StyledDatePickerWrapper = styled(Box)<BoxProps>(() => ({
  width: '160px',
  display: 'flex',
  alignItems: 'end'
}));
